// Copyright © 2024 Broadcom Inc. and its subsidiaries. All Rights Reserved.
import get from "lodash/get";

const styles = ({ margin, padding, color, spacing }) => ({
  titleContainer: {
    marginTop: get(margin, 'm20'),
    borderBottom: `1px solid ${get(color, 'borderColor')}`,
    paddingLeft: get(padding, 'p20'),
    paddingBottom: get(padding, 'p20'),
  },
  descriptionContainer : {
    paddingLeft: get(padding, 'p20'),
    paddingBottom: get(padding, 'p20'),
  },
  assetContainer : {
    paddingLeft: get(padding, 'p20'),
    paddingBottom: get(padding, 'p20'),
    paddingRight : get(padding, 'p20'),
  },
  ssgUrlContainer : {
    paddingTop : get(padding, 'p5'),
  },
  filterByApiNameContainer : {
    margin : '0px !important',
    paddingLeft : get(padding, 'p10'),
    paddingRight : get(padding, 'p10'),
  },
  paginationContainer : {
    display : 'flex',
    justifyContent : 'space-between',
    padding : get(padding, 'p5'),
    marginTop : get(margin, 'm5'),
    '& .MuiButton-root.Mui-disabled' : {
      border : '0px !important',
      backgroundColor: 'transparent !important',
    },
  },
  expandPanelToolbar : {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'left',
    backgroundColor: '#FBFBFB',
  },
  summaryRoot: {
    padding: 0,
    display : 'flex',
    justifyContent : 'flex-start',
    minHeight: 40,
    '&.Mui-expanded': {
      marginTop: 4,
      minHeight: 40,
    },
    paddingLeft: spacing(1),
  },
  summaryExpandIcon: {
    padding : 0,
    justifyContent : 'center',
  },
  summaryContent: {
    '&.Mui-expanded': {
      margin: 0,
    },
    margin : 0,
    '&.Mui-expanded > p': {
      backgroundColor: `rgba(17, 69, 153, 0.08) !important`,
    },
    paddingRight : 8,
  },
  summaryTitle : {
    alignSelf : 'center',
    width : '100%',
  },
  searchFieldClass : {
    paddingTop : '0px !important',
  },
  expandPanelDetails : {
    padding : '0px !important',
    display : 'inherit',
    position : 'relative',
  },
  expandPanelDetailsContent : {
    marginLeft : 20,
  },
  panelRoot: {
    boxShadow: 'none',
    '&.Mui-expanded': {
      marginBottom: 0,
      marginTop: 0,
    },
    '& .MuiExpansionPanelSummary-expandIcon': {
      color: get(color, 'primary'),
    },
  },
  noDocContainer : {
    padding : get(padding, 'p10'),
    color : get(color, 'secondaryText'),
  },
});

export default styles;
